import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Equipment_ds_equipment_editorService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { equipmentId: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, MacAddress?: string, TypeId?: number, LocationContainers?: { LocationContainerId?: number, LocationContainer?: { Id?: number, Name?: string, Warehouse?: { Id?: number, Name?: string } } }[], Type?: { Id?: number, CanHandleFullLPTasksOperations?: boolean, LookupCode?: string, MobileLaunchPickDropAfterPickp?: boolean, MobilePickingDisableAutoConfirmOnTargetLp?: boolean } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.equipmentId)) {
      missingRequiredInParams.push('\'equipmentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Equipment/datasources/ds_equipment_editor/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      equipmentId: number    }) {
        if(isNil(inParams.equipmentId)) {
          return true; 
        }
      return false;
    }
}
